import React, { useEffect, useState } from "react";
import { Input, Modal, Spin } from "antd";
import { LuX } from "react-icons/lu";
import {
  DEFAULT_PANEL_LINK_HEADER_SUBTITLE,
  DEFAULT_PANEL_LINK_MESSAGE_BODY,
  PANEL_LINK_MESSAGE_GREETING,
} from "../../pages/admin/PanelUser/helpers";

const headerInputClassName =
  "rounded-lg border-0 bg-white/10 text-center text-white placeholder:text-white/60 shadow-none focus:bg-white/15";

const SendPanelLinkModal = ({ visible, onClose, onSend, isSending }) => {
  const [headerSubtitle, setHeaderSubtitle] = useState(
    DEFAULT_PANEL_LINK_HEADER_SUBTITLE,
  );
  const [messageBody, setMessageBody] = useState(DEFAULT_PANEL_LINK_MESSAGE_BODY);

  useEffect(() => {
    if (visible) {
      setHeaderSubtitle(DEFAULT_PANEL_LINK_HEADER_SUBTITLE);
      setMessageBody(DEFAULT_PANEL_LINK_MESSAGE_BODY);
    }
  }, [visible]);

  const canSend = headerSubtitle.trim() && messageBody.trim();

  const handleSend = () => {
    onSend({
      header_subtitle: headerSubtitle.trim(),
      message_body: messageBody.trim(),
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={520}
      title={null}
      closeIcon={
        <div className="bg-secondary z-10 h-8 w-8 flex justify-center items-center rounded-full">
          <LuX className="text-red-400" size={20} />
        </div>
      }
      className="send-panel-link-modal"
      destroyOnClose
      centered
      styles={{ body: { padding: 0 } }}
    >
      <div
        className="rounded-t-2xl px-6 py-10 text-center text-white"
        style={{
          background: "linear-gradient(135deg, #4d94ff 0%, #2563eb 100%)",
        }}
      >
        <h2 className="m-0 text-2xl font-bold tracking-tight">Unzippd</h2>
        <Input
          value={headerSubtitle}
          onChange={(e) => setHeaderSubtitle(e.target.value)}
          variant="borderless"
          placeholder="Header subtitle"
          className={`${headerInputClassName} mt-2 !text-base !text-white/90`}
        />
      </div>
      <div className="py-4">
        <div className="rounded-2xl border border-gray-200 bg-white px-4 py-3">
          <p className="mb-2 text-sm font-medium text-gray-900">
            {PANEL_LINK_MESSAGE_GREETING}
          </p>
          <Input.TextArea
            value={messageBody}
            onChange={(e) => setMessageBody(e.target.value)}
            rows={6}
            variant="borderless"
            className="!p-0 !text-sm text-gray-700 shadow-none"
            placeholder="Enter your message..."
          />
        </div>
        <div className="mt-4 flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-[50%] h-10 btnSecondary border rounded-2xl text-gray-700 font-medium"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSend}
            disabled={isSending || !canSend}
            className="w-[50%] h-10 bg-[#18181B] text-white rounded-2xl border-0 font-medium disabled:opacity-60"
          >
            {isSending ? <Spin size="small" /> : "Send link"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SendPanelLinkModal;
